import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '../../services';
import { NavItem } from '../../types';

@Component({
  selector: 'app-sidebar',
  standalone: false,
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css',
})
export class Sidebar implements OnInit {
  collapsed = false;
  mobileOpen = false;
  isMobile = false;
  activeRoute = '';
  expandedGroup: string | null = null;
  showLogoutModal = false;

  navItems: NavItem[] = [
    { label: 'Dashboard', icon: 'bi-grid', route: '/dashboard' },
    {
  label: 'Academic',
  icon: 'bi-building',
  children: [
    { label: 'Subjects', icon: 'bi-journal-bookmark', route: '/dashboard/subjects' },

    { label: 'Subject Offerings', icon: 'bi-collection', route: '/dashboard/subject-offerings' },

    { label: 'Academic Years', icon: 'bi-calendar-range', route: '/dashboard/academic-years' }
  ],
},
    {
      label: 'People',
      icon: 'bi-people',
      children: [
        { label: 'Students', icon: 'bi-person-badge', route: '/dashboard/students' },
        { label: 'Staff', icon: 'bi-person-gear', route: '/dashboard/staff' },
      ],
    },
    { label: 'Materials', icon: 'bi-folder2-open', route: '/dashboard/content' },
    { label: 'AI Learning', icon: 'bi-lightning', route: '/dashboard/ai-learning' },
    { label: 'Activation Codes', icon: 'bi-key', route: '/dashboard/activation-codes' },
    { label: 'Settings', icon: 'bi-gear', route: '/dashboard/settings' },
  ];

  constructor(private router: Router, private auth: AuthService) {}

  ngOnInit(): void {
    this.checkScreenSize();
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        this.activeRoute = e.urlAfterRedirects;
        if (this.isMobile) this.mobileOpen = false;
      });
    this.activeRoute = this.router.url;
  }

  @HostListener('window:resize')
  checkScreenSize(): void {
    this.isMobile = window.innerWidth < 1024;
    if (!this.isMobile) {
      this.mobileOpen = false;
    }
  }

  toggleSidebar(): void {
    if (this.isMobile) {
      this.mobileOpen = !this.mobileOpen;
    } else {
      this.collapsed = !this.collapsed;
      if (this.collapsed) this.expandedGroup = null;
    }
  }

  openMobile(): void {
    this.mobileOpen = true;
  }

  closeMobile(): void {
    this.mobileOpen = false;
  }

  toggleGroup(label: string): void {
    if (this.collapsed && !this.isMobile) {
      this.collapsed = false;
    }
    this.expandedGroup = this.expandedGroup === label ? null : label;
  }

  isGroupActive(item: NavItem): boolean {
    return item.children?.some((c) => this.activeRoute.startsWith(c.route || '')) ?? false;
  }

  navigate(route: string): void {
    this.router.navigate([route]);
    if (this.isMobile) this.mobileOpen = false;
  }

  openLogoutModal(): void {
    this.showLogoutModal = true;
  }

  closeLogoutModal(): void {
    this.showLogoutModal = false;
  }

  confirmLogout(): void {
    this.showLogoutModal = false;
    this.auth.logout();
  }

  getUser() {
    return this.auth.getUser();
  }

 getRoleLabel(): string {
  const roles = this.auth.getNormalizedRoles();

  if (roles.includes('super_admin')) return 'Super Admin';
  if (roles.includes('admin')) return 'Admin';
  if (roles.includes('teacher')) return 'Teacher';
  if (roles.includes('student')) return 'Student';

  return 'User';
}
}